import type { FC } from "react";
import { colours } from "../../styles/colours.constants";
import Icon from "../icon/icon";
import type { ToolbarOptionConfig } from "./toolbar-dropdown.types";
import * as CSS from "./toolbar-dropdown.styles";

type ToolbarDropdownProps = {
	items: ToolbarOptionConfig[];
	onMenuItemSelected?: (id: string) => void;
	align?: "left" | "right";
};

const ToolbarDropdown: FC<ToolbarDropdownProps> = ({
	items,
	onMenuItemSelected,
	align = "left",
}) => {
	if (!onMenuItemSelected) {
		return null;
	}

	return (
		<CSS.ToolbarDropdownMenu $align={align}>
			{items.map((item) => (
				<CSS.DropdownItem
					key={item.id}
					onClick={() => onMenuItemSelected(item.id)}
				>
					<Icon icon={item.icon} color={colours.white} size={22} />
					<CSS.Label>{item.label}</CSS.Label>
				</CSS.DropdownItem>
			))}
		</CSS.ToolbarDropdownMenu>
	);
};

export default ToolbarDropdown;
